module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/assessment_achievements/3_f77e440415121f00199157708c2e22f5.jpg";